import React from 'react';
import NinjaGame from './NinjaGame';

/**
 * ModernNinja is the main entry point for the MNP Standards Trainer.
 * It uses the shared NinjaGame engine to provide the full suite of drills.
 */
const ModernNinja = () => {
    return <NinjaGame initialDrillIndex={0} />;
};

export default ModernNinja;
